export const names = {
    ADDRESS: 'Address line',
    CITY: 'City',
    CONTRACT_ID: `Contract name`,
    COUNTY: 'County',
    DATA_PROTECTION_ID: 'Data Protection',
    ELIGIBILITY_GROUP_ID: 'Eligibility group',
    EMAIL: 'Email',
    FIRST_NAME: 'First name',
    GENDER: 'Gender',
    HIRING_MANAGER_ID: 'Hiring manager',
    JOB_SECTOR_ID: 'Job sector',
    LAST_NAME: 'Last name',
    MIDDLE_NAME: 'Middle name',
    NHS_NUMBER: 'NHS Number',
    NINO: 'NINO',
    PHONE: 'Phone number',
    PREFERRED_NAME: 'Preferred name',
    PREFERRED_PRONOUNS_OTHER: 'Preferred pronouns other',
    SERVICE_ID: 'Service name',
    STATUS_ID: 'Status',
    STATUS_REASON_ID: 'Status reason',
    TEAM_ID: 'Team name',
    POSTCODE: 'Postcode'
};

export const regExps = {
    CURRENCY_R: /(\.\d{2})\d+/g,
    DECIMALS_R: /[^0-9.]/g,
    DIGITS_R: /[^\d]/g,
    EMAIL_R:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    HTML_R: /<[^>]*>/gi,
    NAME_R: /^[A-Za-z\s]+$/i,
    NINO_R: /^(?!BG)(?!GB)(?!NK)(?!KN)(?!TN)(?!NT)(?!ZZ)[A-CEGHJ-PR-TW-Z][A-CEGHJ-NPR-TW-Z](?:\s*\d\s*){6}([A-D]|\s)$/i,
    LAST_NAME_R: /^([A-Za-z'\s-]+)?$/,
    NUMBERS_R: /^\d+$/,
    PAY_R: /^\d{0,3}(\.\d{1,2})?$/i,
    PHONE_R: /^[\\+]?[(]?[0-9]{2,3}[)]?[-\s\\.]?[0-9]{3,4}[-\s\\.]?[0-9]{4,8}$/,
    PO_NUMBER: /[^0-9a-z\s\-/]/gi,
    POSTCODE_R: /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0A{2})$/i,
    PRICE_R: /^\d{0,4}(\.\d{1,2})?$/i,
    PT_BATCH_FILE_NAME_R: /^(po_)[0-9]+\.(csv|pdf)$/i,
    SEARCH_R: /[^0-9a-z\s-,.@']/gi,
    SECURE_URL_R: /^(https:\/\/)([\w-]+\.)+[\w-]+(\/[\w- ./?%&={}"]*)*$/,
    WEBSITE_R: /^[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)$/i,
    EXTERNAL_REFERENCE_NUMBER_R: /[^a-zA-Z0-9\-.,/]/g,
    REMOVE_SPACES: /\s+/gu
};

export const ALLOWED_ACCENTED_CHARACTERS =
    'ÀÁÂÃÄÅĀĂĄÆÇĆĈĊČÐĎĐÈÉÊËĒĔĖĘĚĜĞĠĢĤĦÌÍÎÏĨĪĬĮİĲĴĶĹĻĽĿŁÑŃŅŇŊÒÓÔÕÖØŌŎŐŒŔŖŘŚŜŞŠßŤŦÙÚÛÜŨŪŬŮŰŲŴÝŶŸŹŻŽàáâãäåāăąæçćĉċčðďđèéêëēĕėęěĝğġģĥħìíîïĩīĭįıĳĵķĺļľŀłñńņňŋòóôõöøōŏőœŕŗřśŝşšſťŧùúûüũūŭůűųŵýÿŷźżž';

// Cache compiled name regular expressions keyed by their option combinations.
const nameRegExpCache = new Map();

const buildNameRegExp = ({
    allowApostrophe = false,
    allowHyphen = false,
    required = true
} = {}) => {
    // Build a stable cache key from the boolean options.
    const cacheKey = [1, allowApostrophe ? 1 : 0, allowHyphen ? 1 : 0, required ? 1 : 0].join('|');

    const cached = nameRegExpCache.get(cacheKey);
    if (cached) {
        return cached;
    }

    const apostropheChars = allowApostrophe ? "'" : '';
    const hyphenChars = allowHyphen ? '\\-' : '';
    const value = `[A-Za-z${ALLOWED_ACCENTED_CHARACTERS}${apostropheChars}${hyphenChars}\\s]+`;

    const regexp = new RegExp(
        `^${required ? value : `(?:${value})?`}$`, // required: false allows an empty field.
        'u'
    );
    nameRegExpCache.set(cacheKey, regexp);

    return regexp;
};

export const getNameRegExp = (options = {}) =>
    buildNameRegExp({ ...options, allowHyphen: options.allowHyphen ?? true });

export const getLastNameRegExp = () =>
    buildNameRegExp({
        allowApostrophe: true,
        allowHyphen: true,
        required: false
    });
